import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import InputBase from '@material-ui/core/InputBase';
import { makeStyles } from '@material-ui/core/styles';
import { inputStyles } from '../../pages/ProductLandingPage/content/ProductPageBody/styles';
import { AmountFieldWrapper, AmountFieldBtn } from './styles';

const styles = makeStyles(inputStyles);

const AmountField = ({
  value, updateValue, max, min,
}) => {
  const [currentValue, setCurrentValue] = useState(value);

  const inputClasses = styles();
  useEffect(() => {
    updateValue(currentValue);
  }, [currentValue]);

  const increaseValue = () => {
    setCurrentValue(currentValue < max ? currentValue + 1 : max);
  };

  const decreaseValue = () => {
    setCurrentValue(currentValue > min ? currentValue - 1 : min);
  };

  return (
    <AmountFieldWrapper>
      <AmountFieldBtn onClick={decreaseValue}>-</AmountFieldBtn>
      <InputBase
        className={inputClasses.root}
        type="number"
        value={currentValue}
        onChange={(v) => setCurrentValue(+v)}
        min={min}
      />
      <AmountFieldBtn onClick={increaseValue}>+</AmountFieldBtn>
    </AmountFieldWrapper>
  );
};

AmountField.defaultProps = {
  value: 0,
  max: 999,
  min: 0,
};

AmountField.propTypes = {
  value: PropTypes.number,
  max: PropTypes.number,
  min: PropTypes.number,
  updateValue: PropTypes.func.isRequired,
};

export default AmountField;
